<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('users')">
        Users
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.first_name"
            :error="form.errors.first_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Depan" />
          <text-input
            v-model="form.last_name"
            :error="form.errors.last_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Belakang" />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Email" />
          <text-input
            v-model="form.bank_acc_number"
            :error="form.errors.bank_acc_number"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nomor Rekening Bank" />
          <select-input
            v-model="form.roles"
            :error="form.errors.roles"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Role">
            <option value="mahasiswa">
              Mahasiswa
            </option>
            <option value="admin">
              Admin
            </option>
          </select-input>
          <text-input
            v-model="form.password"
            :error="form.errors.password"
            class="pr-6 pb-8 w-full lg:w-1/2"
            type="password"
            autocomplete="new-password"
            label="Password" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create
            User
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Create User' },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        'inertia-link': Link,
    },
    layout: Layout,
    remember: 'form',
    data () {
        return {
            form: useForm({
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                roles: 'mahasiswa',
                bank_acc_number: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post(this.route('users.store'))
        },
    },
}
</script>
